module.exports = __webpack_public_path__ + "static/media/Decision.6888ea3a.svg";